"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RoRo API
 * This documents RoRo APIs for handling public facing App needs
 *
 * The version of the OpenAPI document: 0.0.43
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var AuthApi = (function (_super) {
    __extends(AuthApi, _super);
    function AuthApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * fetch user personalInfo
     */
    AuthApi.prototype.fetchUserProfileRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/auth/profile",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserProfileFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * fetch user personalInfo
     */
    AuthApi.prototype.fetchUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchUserProfileRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * update user personalInfo partially
     */
    AuthApi.prototype.partaillyUpdateUserProfileRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.firstName === null || requestParameters.firstName === undefined) {
                            throw new runtime.RequiredError('firstName', 'Required parameter requestParameters.firstName was null or undefined when calling partaillyUpdateUserProfile.');
                        }
                        if (requestParameters.lastName === null || requestParameters.lastName === undefined) {
                            throw new runtime.RequiredError('lastName', 'Required parameter requestParameters.lastName was null or undefined when calling partaillyUpdateUserProfile.');
                        }
                        queryParameters = {};
                        if (requestParameters.firstName !== undefined) {
                            queryParameters['firstName'] = requestParameters.firstName;
                        }
                        if (requestParameters.lastName !== undefined) {
                            queryParameters['lastName'] = requestParameters.lastName;
                        }
                        if (requestParameters.birthDate !== undefined) {
                            queryParameters['birthDate'] = requestParameters.birthDate.toISOString().substr(0, 10);
                        }
                        if (requestParameters.email !== undefined) {
                            queryParameters['email'] = requestParameters.email;
                        }
                        if (requestParameters.gender !== undefined) {
                            queryParameters['gender'] = requestParameters.gender;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/auth/profile",
                                method: 'PATCH',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.UserProfileFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * update user personalInfo partially
     */
    AuthApi.prototype.partaillyUpdateUserProfile = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.partaillyUpdateUserProfileRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Registers user with given personalInfo
     */
    AuthApi.prototype.registerUserRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.firstName === null || requestParameters.firstName === undefined) {
                            throw new runtime.RequiredError('firstName', 'Required parameter requestParameters.firstName was null or undefined when calling registerUser.');
                        }
                        if (requestParameters.lastName === null || requestParameters.lastName === undefined) {
                            throw new runtime.RequiredError('lastName', 'Required parameter requestParameters.lastName was null or undefined when calling registerUser.');
                        }
                        queryParameters = {};
                        if (requestParameters.firstName !== undefined) {
                            queryParameters['firstName'] = requestParameters.firstName;
                        }
                        if (requestParameters.lastName !== undefined) {
                            queryParameters['lastName'] = requestParameters.lastName;
                        }
                        if (requestParameters.birthDate !== undefined) {
                            queryParameters['birthDate'] = requestParameters.birthDate.toISOString().substr(0, 10);
                        }
                        if (requestParameters.email !== undefined) {
                            queryParameters['email'] = requestParameters.email;
                        }
                        if (requestParameters.gender !== undefined) {
                            queryParameters['gender'] = requestParameters.gender;
                        }
                        if (requestParameters.nationalId !== undefined) {
                            queryParameters['nationalId'] = requestParameters.nationalId;
                        }
                        if (requestParameters.nidOtp !== undefined) {
                            queryParameters['nidOtp'] = requestParameters.nidOtp;
                        }
                        if (requestParameters.oneTimeRideCode !== undefined) {
                            queryParameters['oneTimeRideCode'] = requestParameters.oneTimeRideCode;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/auth/register",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Registers user with given personalInfo
     */
    AuthApi.prototype.registerUser = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.registerUserRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Requests a verification code
     */
    AuthApi.prototype.requestAuthCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.phone === null || requestParameters.phone === undefined) {
                            throw new runtime.RequiredError('phone', 'Required parameter requestParameters.phone was null or undefined when calling requestAuthCode.');
                        }
                        queryParameters = {};
                        if (requestParameters.phone !== undefined) {
                            queryParameters['phone'] = requestParameters.phone;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/auth/login/code",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AuthCodeResultFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Requests a verification code
     */
    AuthApi.prototype.requestAuthCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestAuthCodeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * request otp code for nationalId verification
     */
    AuthApi.prototype.requestNationalIdOtpRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.nationalId === null || requestParameters.nationalId === undefined) {
                            throw new runtime.RequiredError('nationalId', 'Required parameter requestParameters.nationalId was null or undefined when calling requestNationalIdOtp.');
                        }
                        queryParameters = {};
                        if (requestParameters.nationalId !== undefined) {
                            queryParameters['nationalId'] = requestParameters.nationalId;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/auth/nid-otp",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * request otp code for nationalId verification
     */
    AuthApi.prototype.requestNationalIdOtp = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestNationalIdOtpRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Verifies user\'s code
     */
    AuthApi.prototype.verifyAuthCodeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.codeKey === null || requestParameters.codeKey === undefined) {
                            throw new runtime.RequiredError('codeKey', 'Required parameter requestParameters.codeKey was null or undefined when calling verifyAuthCode.');
                        }
                        if (requestParameters.code === null || requestParameters.code === undefined) {
                            throw new runtime.RequiredError('code', 'Required parameter requestParameters.code was null or undefined when calling verifyAuthCode.');
                        }
                        queryParameters = {};
                        if (requestParameters.codeKey !== undefined) {
                            queryParameters['codeKey'] = requestParameters.codeKey;
                        }
                        if (requestParameters.code !== undefined) {
                            queryParameters['code'] = requestParameters.code;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/auth/login/verify",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AuthResultFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Verifies user\'s code
     */
    AuthApi.prototype.verifyAuthCode = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyAuthCodeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * verify nationalId using otp code
     */
    AuthApi.prototype.verifyNationalIdOtpRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.otp === null || requestParameters.otp === undefined) {
                            throw new runtime.RequiredError('otp', 'Required parameter requestParameters.otp was null or undefined when calling verifyNationalIdOtp.');
                        }
                        queryParameters = {};
                        if (requestParameters.otp !== undefined) {
                            queryParameters['otp'] = requestParameters.otp;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/auth/nid-verify",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * verify nationalId using otp code
     */
    AuthApi.prototype.verifyNationalIdOtp = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.verifyNationalIdOtpRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return AuthApi;
}(runtime.BaseAPI));
exports.AuthApi = AuthApi;
/**
    * @export
    * @enum {string}
    */
var PartaillyUpdateUserProfileGenderEnum;
(function (PartaillyUpdateUserProfileGenderEnum) {
    PartaillyUpdateUserProfileGenderEnum["Male"] = "MALE";
    PartaillyUpdateUserProfileGenderEnum["Female"] = "FEMALE";
})(PartaillyUpdateUserProfileGenderEnum = exports.PartaillyUpdateUserProfileGenderEnum || (exports.PartaillyUpdateUserProfileGenderEnum = {}));
/**
    * @export
    * @enum {string}
    */
var RegisterUserGenderEnum;
(function (RegisterUserGenderEnum) {
    RegisterUserGenderEnum["Male"] = "MALE";
    RegisterUserGenderEnum["Female"] = "FEMALE";
})(RegisterUserGenderEnum = exports.RegisterUserGenderEnum || (exports.RegisterUserGenderEnum = {}));
